import React from "react";
import { useTranslation } from "react-i18next";
import { AiFillFileExcel } from "react-icons/ai";

function ExportExcel({
  isExportModelOpen,
  setIsExportModelOpen,
  handleExportExcel,
  handleCancel,
}) {
  const { t } = useTranslation("admClass");

  return (
    <div>
      <button
        onClick={() => setIsExportModelOpen(true)}
        className="flex justify-center items-center gap-x-2 px-4 py-2 rounded-md bg-gradient-to-r from-pink-100 to-purple-200"
      >
        <AiFillFileExcel className="text-lg text-red-600" />
        <span className="text-gradient">{t("Export Excel")}</span>
      </button>
      {isExportModelOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[350px] relative">
            <h2 className="text-lg font-semibold mb-4">
              {t("Export Job Applications")}
            </h2>

            <p className="text-sm text-gray-600 mb-6">
              {t("Click export to download all job applications as an Excel file.")}
            </p>

            <form onSubmit={handleExportExcel}>
              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={handleCancel}
                  className="bg-white px-4 py-2 rounded-md border border-gray-300"
                >
                  {t("Cancel")}
                </button>

                <button
                  type="submit"
                  className="btn-gradient text-white px-4 py-2 "
                >
                  {t("Export")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ExportExcel;